module.exports = __webpack_public_path__ + "img/appAsset-cardbrand--MasterCard.4d884409.svg";